import React from 'react';
import { styled } from '@mui/material/styles';

const StyledDiv = styled('div')(({ theme }: any) => {
  return {
    padding: theme.spacing(2),
  };
});
export default StyledDiv;
